export default "__VITE_ASSET__CjZg$Ju6__"